import React, { useEffect } from 'react';
import PermissionsWrapper from './Layout/UIContainer/PermissionsWrapper';
import { InteractionStatus } from '@azure/msal-browser';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import {
  ThemeContext,
  PreferredThemeContext,
  useToggleDarkMode,
} from '../Theme/UseToggleDarkMode';
import { Toaster } from 'sonner';
import '../i18n';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { login } from '../Auth/AuthProvider';
import createAppTheme from '../Theme/AppTheme';

const App = () => {
  const [prefersDarkMode, , setColorMode] = useToggleDarkMode();
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      login();
    }
  }, [isAuthenticated, inProgress]);

  const theme = React.useMemo(
    () => createAppTheme(prefersDarkMode ? 'dark' : 'light'),
    [prefersDarkMode],
  );

  const toggleTheme = React.useCallback(() => {
    setColorMode();
  }, [setColorMode]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ThemeContext.Provider value={toggleTheme}>
          <PreferredThemeContext.Provider value={prefersDarkMode}>
            <>
              <Toaster position="top-right" richColors />
              <PermissionsWrapper />
            </>
          </PreferredThemeContext.Provider>
        </ThemeContext.Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
